@if (data$ | async) {
  <div class="flow">
    <ng-container>
      <mat-horizontal-stepper linear #stepper class="no-stepper-nav">
        <mat-step #firststep>
          <div class="flow__nav">
            <button class="btn-icon blue" type="button" (click)="goToSubscription()">
              <mat-icon>chevron_left</mat-icon>
              <span>Tilbage</span>
            </button>
            <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
              <mat-icon svgIcon="remove"></mat-icon>
            </button>
            <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
          </div>
          <div class="flow__stage">
            <div class="flow__step-content">
              <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
              <h1 class="medium">Hvilke tilvalg ønsker kunden?</h1>
              <app-edit-tilvalg-form
                [form]="tilvalgForm"
                [tilvalgGroups]="tilvalgGroups"
                [serviceaftale]="serviceaftale"
                [serviceaftaleChanged]="false"
              ></app-edit-tilvalg-form>
              <div>
                <button mat-raised-button matStepperNext color="primary" [disabled]="!tilvalgForm?.dirty || tilvalgForm?.invalid">
                  Videre
                </button>
              </div>
            </div>
            <ng-container *ngTemplateOutlet="flowResume"></ng-container>
          </div>
        </mat-step>
        @if (afregninger?.length > 0 && !upcomingChange) {
          <mat-step #krediterstep>
            <div class="flow__nav">
              <button matStepperPrevious class="btn-icon blue" type="button">
                <mat-icon>chevron_left</mat-icon>
                <span>Tilbage</span>
              </button>
              <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
                <mat-icon svgIcon="remove"></mat-icon>
              </button>
              <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
            </div>
            <div class="flow__stage">
              <div class="flow__step-content">
                <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
                <h1 class="medium">
                  Der er allerede sket {{ afregninger?.length }} opkrævninger!
                  <br />
                  <span class="regular">Hvad skal der ske?</span>
                </h1>
                <div>
                  <form [formGroup]="opkraevningForm" [attr.autocomplete]="'off'">
                    <mat-radio-group formControlName="opkraevningType" class="strong-labels">
                      <div class="flow__opt-detail">
                        <mat-radio-button [value]="1">Krediter tidligere opkrævning og opkræv på ny</mat-radio-button>
                        @if (currentPrice?.fastprisaftale || newPrice?.fastprisaftale) {
                          <div class="fastprisaftale orange icon-with-text">
                            <mat-icon svgIcon="obs-solid" class="orange margin--right-xs"></mat-icon>
                            <span>En eller flere opkrævninger er med fastprisaftale</span>
                          </div>
                        }
                        <div class="flex-wrap flex-wrap--flex-start">
                          <div>
                            <strong>Opkrævninger til gammel pris</strong>
                            <table class="tiny-text">
                              @for (opkraevning of afregninger; track opkraevning) {
                                <tr>
                                  <td>Abn. opkrævning d. {{ opkraevning.opkraevningDate | date: 'dd.MM.yyyy' }}</td>
                                  <td class="align-right">
                                    @if (currentPrice?.preferredShownWithMoms) {
                                      <div>
                                        <strong>{{ opkraevning.beloebMedMoms | dkCurrency }}</strong>
                                      </div>
                                    }
                                    @if (!currentPrice?.preferredShownWithMoms) {
                                      <div>
                                        <strong>
                                          {{ opkraevning.beloebMedMoms | dkCurrency }}
                                          <span class="cursor-help" matTooltip="Ekskl. moms">
                                            <span ngNonBindable>&#123;</span>
                                            {{ opkraevning.beloebExclMoms | dkCurrency }}&#125;
                                          </span>
                                        </strong>
                                      </div>
                                    }
                                  </td>
                                </tr>
                              }
                            </table>
                          </div>
                          <div class="flow__arrow">
                            <mat-icon class="orange">chevron_right</mat-icon>
                          </div>
                          <div class="orange">
                            <strong>Opkrævninger til ny pris</strong>
                            <table class="tiny-text">
                              @for (op of afregninger; track op) {
                                <tr>
                                  <td>Ny opkrævning</td>
                                  <td class="align-right">
                                    @if (newPrice?.preferredShownWithMoms) {
                                      <div>
                                        <strong>{{ newPrice?.opkraevning.amount.withMoms | dkCurrency }}</strong>
                                      </div>
                                    }
                                    @if (!newPrice?.preferredShownWithMoms) {
                                      <div>
                                        <strong>
                                          {{ newPrice?.opkraevning.amount.withMoms | dkCurrency }}
                                          <span class="cursor-help" matTooltip="Ekskl. moms">
                                            <span ngNonBindable>&#123;</span>
                                            {{ newPrice?.opkraevning.amount.withoutMoms | dkCurrency }}&#125;
                                          </span>
                                        </strong>
                                      </div>
                                    }
                                  </td>
                                </tr>
                              }
                            </table>
                          </div>
                        </div>
                      </div>
                      <div>
                        <mat-radio-button [value]="2">Prisændring gælder kun fremadrettet</mat-radio-button>
                      </div>
                    </mat-radio-group>
                  </form>
                </div>
                <div>
                  <button mat-raised-button matStepperNext color="primary" [disabled]="!opkraevningForm?.dirty || opkraevningForm?.invalid">
                    Videre
                  </button>
                </div>
              </div>
              <ng-container *ngTemplateOutlet="flowResume"></ng-container>
            </div>
          </mat-step>
        }
        @if (!isGarantiNaerVarmeLeasingGasTryghed) {
          <mat-step #sendLetterStep>
            <div class="flow__nav">
              <button matStepperPrevious class="btn-icon blue" type="button">
                <mat-icon>chevron_left</mat-icon>
                <span>Tilbage</span>
              </button>
              <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
                <mat-icon svgIcon="remove"></mat-icon>
              </button>
              <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
            </div>
            <div class="flow__stage">
              <div class="flow__step-content">
                <h1 class="medium">Skal der sendes et brev til kunden?</h1>
                <app-send-letter
                  [form]="sendLetterForm"
                  [email]="$safeNavigationMigration(serviceaftale?.kunde?.anlaegsadresse?.email)"
                  (reload)="reloadServiceAftale()"
                ></app-send-letter>
                <div class="flow__step-actions">
                  <button mat-raised-button matStepperNext color="primary" [disabled]="$safeNavigationMigration(sendLetterForm?.invalid)">Videre</button>
                </div>
              </div>
            </div>
          </mat-step>
        }
        <mat-step #confirmstep>
          <div class="flow__nav">
            <button matStepperPrevious class="btn-icon blue" type="button">
              <mat-icon>chevron_left</mat-icon>
              <span>Tilbage</span>
            </button>
            <button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
              <mat-icon svgIcon="remove"></mat-icon>
            </button>
            <a class="blue" (click)="quickViewOpen = true">Se aftale</a>
          </div>
          <div class="flow__stage">
            <div class="flow__step-confirm">
              <ng-container *ngTemplateOutlet="stepHeader"></ng-container>
              @if (!upcomingChange) {
                <h1 class="medium">Er disse ændringer korrekte?</h1>
              }
              @if (upcomingChange) {
                <h1 class="medium">
                  Ændringen træder i kraft d. {{ validFrom | date: 'dd.MM.yyyy' }}
                  @if (serviceaftale.currentServiceinterval) {
                    <span>når nuværende serviceperiode er slut</span>
                  }
                </h1>
              }
              <div class="flow__opt-detail margin--top-xl">
                @for (tilvalgGroup of tilvalgGroups; track tilvalgGroup) {
                  <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                    <div>
                      <div>{{ tilvalgGroup.name }}</div>
                      <strong>{{ getCurrentTilvalg(tilvalgGroup) }}</strong>
                    </div>
                    <div class="flow__arrow">
                      <mat-icon class="orange">chevron_right</mat-icon>
                      <mat-icon class="blue" svgIcon="edit"></mat-icon>
                    </div>
                    <div class="orange">
                      <div>
                        <div>{{ tilvalgGroup.name }}</div>
                        <strong>{{ getNewTilvalg(tilvalgGroup) }}</strong>
                      </div>
                    </div>
                  </div>
                }
                <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                  <div>
                    <div>Tidligere opkrævet i alt</div>
                    @if (afregninger.length > 0) {
                      @if (currentPrice?.preferredShownWithMoms) {
                        <strong>{{ afregningerTotalMedMoms | dkCurrency }}</strong>
                      }
                      @if (!currentPrice?.preferredShownWithMoms) {
                        <strong>
                          {{ afregningerTotalMedMoms | dkCurrency }}
                          <span class="cursor-help" matTooltip="Ekskl. moms">
                            <span ngNonBindable>&#123;</span>
                            {{ afregningerTotalExclMoms | dkCurrency }}&#125;
                          </span>
                        </strong>
                      }
                    }
                    @if (afregninger.length == 0) {
                      <strong>{{ 0 | dkCurrency }}</strong>
                    }
                  </div>
                  <div class="flow__arrow">
                    <mat-icon class="orange">chevron_right</mat-icon>
                    <mat-icon class="blue" svgIcon="edit"></mat-icon>
                  </div>
                  <div class="orange">
                    @if (opkraevningType.value === 1) {
                      <div>
                        <div>Korrektion tidl. opkræver (i alt)</div>
                        <strong>
                          Krediteres:
                          @if (currentPrice?.preferredShownWithMoms) {
                            {{ afregningerTotalMedMoms * -1 | dkCurrency }}
                          }
                          @if (!currentPrice?.preferredShownWithMoms) {
                            {{ afregningerTotalMedMoms * -1 | dkCurrency }}
                            <span class="cursor-help" matTooltip="Ekskl. moms">
                              <span ngNonBindable>&#123;</span>
                              {{ afregningerTotalExclMoms * -1 | dkCurrency }}&#125;
                            </span>
                          }
                        </strong>
                        <br />
                        <strong>
                          Opkræves ny pris:
                          @if (currentPrice?.preferredShownWithMoms) {
                            <div>
                              <strong>{{ opkraevningerTotalMedMoms | dkCurrency }}</strong>
                            </div>
                          }
                          @if (!currentPrice?.preferredShownWithMoms) {
                            <div>
                              <strong>
                                {{ opkraevningerTotalMedMoms | dkCurrency }}
                                <span class="cursor-help" matTooltip="Ekskl. moms">
                                  <span ngNonBindable>&#123;</span>
                                  {{ opkraevningerTotalExclMoms | dkCurrency }}&#125;
                                </span>
                              </strong>
                            </div>
                          }
                        </strong>
                      </div>
                    }
                    @if (!opkraevningType.value) {
                      <div>
                        <div>Korrektion tidl. opkræver (i alt)</div>
                        <strong>Ingen korrektion</strong>
                      </div>
                    }
                  </div>
                </div>
                <div class="flex-wrap flex-wrap--flex-start" (click)="goToStep(0)">
                  <div>
                    <div>Gammel pris</div>
                    @if (currentPrice?.preferredShownWithMoms) {
                      <strong>{{ $safeNavigationMigration(currentPrice?.listPrice.withMoms) | dkCurrency }}</strong>
                    }
                    @if (!currentPrice?.preferredShownWithMoms) {
                      <strong>
                        {{ $safeNavigationMigration(currentPrice?.listPrice.withMoms) | dkCurrency }}
                        <span class="cursor-help" matTooltip="Ekskl. moms">
                          <span ngNonBindable>&#123;</span>
                          {{ $safeNavigationMigration(currentPrice?.listPrice.withoutMoms) | dkCurrency }}&#125;
                        </span>
                      </strong>
                    }
                  </div>
                  <div class="flow__arrow">
                    <mat-icon class="orange">chevron_right</mat-icon>
                    <mat-icon class="blue" svgIcon="edit"></mat-icon>
                  </div>
                  <div class="orange">
                    <div>
                      <div>Ny pris</div>
                      @if (!newPrice) {
                        <span [matTooltip]="priceError" [matTooltipDisabled]="!priceError"><strong>Kan ikke beregnes</strong></span>
                      }
                      @if (newPrice && newPrice.preferredShownWithMoms) {
                        <strong>{{ $safeNavigationMigration(newPrice?.listPrice.withMoms) | dkCurrency }}</strong>
                      }
                      @if (newPrice && !newPrice.preferredShownWithMoms) {
                        <strong>
                          {{ $safeNavigationMigration(newPrice?.listPrice.withMoms) | dkCurrency }}
                          <span class="cursor-help" matTooltip="Ekskl. moms">
                            <span ngNonBindable>&#123;</span>
                            {{ $safeNavigationMigration(newPrice?.listPrice.withoutMoms) | dkCurrency }}&#125;
                          </span>
                        </strong>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <hr class="margin--top-l" />
              <div class="align-center margin--top-l">
                <button mat-raised-button color="primary" (click)="doChange(stepper)" [disabled]="">Gennemfør ændringer</button>
              </div>
            </div>
          </div>
        </mat-step>
        <mat-step #fourthstep>
          <div class="flow__nav"></div>
          <div class="flow__stage">
            <div class="flow__step-confirm align-center green">
              <mat-icon svgIcon="checkmark" class="icon-64"></mat-icon>
              <br />
              <h2 class="medium">Abonnementet er nu ændret</h2>
              @if (upcomingChange) {
                <div>Træder i kraft fra d. {{ validFrom | date: 'dd.MM.yyyy' }}</div>
              }
              <div>
                <button mat-raised-button color="primary" replaceUrl="true" [routerLink]="['/aftale/', $safeNavigationMigration(serviceaftale?.okKundeAftaleNr)]">
                  Gå til aftalen
                </button>
              </div>
            </div>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </ng-container>
    <ng-template #flowResume>
      <div class="flow__resume">
        <div @fadeSlideInOut>
          <div class="h2 medium">
            Nuværende abonnement
            <br />
            <span class="orange regular">med [rettelser]</span>
          </div>
          @for (tilvalgGroup of tilvalgGroups; track tilvalgGroup) {
            <div class="margin--top-l">
              <strong>{{ tilvalgGroup.name }}</strong>
              <br />
              {{ getCurrentTilvalg(tilvalgGroup) }}
              <br />
              @if (getNewTilvalg(tilvalgGroup)) {
                <span class="orange absolute" @fadeSlideInOut>[{{ getNewTilvalg(tilvalgGroup) }}]</span>
              }
            </div>
          }
        </div>
      </div>
    </ng-template>
    <ng-template #stepHeader>
      <div class="flow__header icon-with-text">
        <mat-icon class="icon-32" [svgIcon]="getProductText(serviceaftale)"></mat-icon>
        Skift tilvalg for {{ getProductText(serviceaftale) }} abonnement
      </div>
    </ng-template>
  </div>
}
@if (quickViewOpen) {
  <div class="quick-view" [@inOutAnimation]>
    <button type="button" class="btn-icon btn-close" (click)="quickViewOpen = false" title="Luk">
      <mat-icon>close</mat-icon>
    </button>
    <app-quickview [serviceaftale]="serviceaftale"></app-quickview>
    <div class="quick-view__bottom">
      <button mat-raised-button color="primary" [routerLink]="['/aftale', serviceaftale.okKundeAftaleNr]">Åben aftalen</button>
    </div>
  </div>
}
